export default function getIsLargePointerDevice() {
    const { matches  } = window.matchMedia("only screen and (min-width:768px) and (hover:hover) and (pointer:fine)");
    return matches;
};
